import React, { useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const DISMISS_KEY = "pw_breach_dismissed_count";

export function PasswordBreachBanner() {
  const { user } = useAuth();
  const breach = user && user.password_breach;
  const count = breach && breach.breached ? breach.count : 0;
  const [dismissed, setDismissed] = useState(() => {
    try { return Number(localStorage.getItem(DISMISS_KEY) || 0); } catch { return 0; }
  });

  if (!count || dismissed === count) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(count)); } catch { /* ignore */ }
    setDismissed(count);
  };

  return (
    <div
      data-testid="password-breach-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[min(92vw,640px)] flex items-start gap-3 rounded-xl border border-amber-500/30 bg-slate-900/95 backdrop-blur px-4 py-3 shadow-xl"
    >
      <ShieldAlert className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
      <div className="text-sm text-slate-200 leading-tight flex-1">
        <div className="font-semibold text-amber-200">Your password has turned up in a data breach</div>
        <div className="text-xs text-slate-400 mt-0.5">
          It appears in {count.toLocaleString()} known breaches. It still works, but we strongly recommend changing it to keep your den secure.
        </div>
        <Link to="/security" data-testid="password-breach-change-link" className="inline-block mt-2 text-xs font-semibold text-sky-300 hover:text-sky-200">
          Change my password →
        </Link>
      </div>
      <button onClick={dismiss} data-testid="password-breach-dismiss" aria-label="Dismiss" className="text-slate-500 hover:text-slate-300 shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
